import type { TFunction } from 'i18next';

import { COIN_BACK_DATA_TEST_ID, COIN_BACK_TUTORIAL_DATA_TEST_ID } from '../../../features/coinbackTutorial/constants';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { floorToDecimals, formatValueWithKFloor } from '../../../utils/helpers';
import { formatNumber } from '../../../utils/numberFormat';

// Coinback must never display more than the player actually collects, so GC
// floors at every tier instead of rounding, and SC is never K/M/B-abbreviated.
export const formatCoinBackBalanceValue = (value: number, coinType: CoinType, t: TFunction) => {
  if (coinType === 'GC') {
    if (value < 100000) {
      return formatNumber(floorToDecimals(value, 2));
    } else {
      const formattedWithK = formatValueWithKFloor(value, t);
      return formattedWithK;
    }
  } else {
    return formatNumber(Math.floor(Number((value * 100).toFixed(6))) / 100);
  }
};

export const getCoinBackDataTestId = (suffix: string, isTutorialOpen: boolean): string => {
  const baseTestId = isTutorialOpen ? COIN_BACK_TUTORIAL_DATA_TEST_ID : COIN_BACK_DATA_TEST_ID;
  return `${baseTestId}-${suffix}`;
};
